export function check_date_time(full_year, month, day, time) {
  // month is 0 indexed
  const target_date = new Date(full_year, month - 1, day, time);
  const obs_date = new Date();
  const UTC_date = new Date(obs_date.getUTCFullYear(), obs_date.getUTCMonth(), obs_date.getUTCDate(), obs_date.getUTCHours());

  if (UTC_date >= target_date) {
    return true
  } else {
    return false 
  }
}
